const EMPTY_LABEL = "Aucun fichier choisi"
const PROMPT_FILE = "Déposer un fichier ici, ou cliquer pour choisir"
const PROMPT_IMAGE = "Déposer une image ici, ou cliquer pour choisir"

const promptFor = (input) => {
  const accept = (input.getAttribute("accept") || "").toLowerCase()
  if (accept.includes("image")) return PROMPT_IMAGE
  return PROMPT_FILE
}

const updateName = (nameEl, input) => {
  const file = input.files && input.files[0]
  nameEl.textContent = file ? file.name : EMPTY_LABEL
  nameEl.classList.toggle("is-filled", Boolean(file))
}

const enhanceFileInput = (input) => {
  if (input.dataset.fileEnhanced === "true") return
  input.dataset.fileEnhanced = "true"

  const wrap = document.createElement("label")
  wrap.className = "backoffice-file"
  if (input.required) wrap.classList.add("backoffice-file--required")

  const ui = document.createElement("span")
  ui.className = "backoffice-file__ui"

  const prompt = document.createElement("span")
  prompt.className = "backoffice-file__prompt"
  prompt.textContent = promptFor(input)

  const name = document.createElement("span")
  name.className = "backoffice-file__name"
  name.textContent = EMPTY_LABEL

  ui.appendChild(prompt)
  ui.appendChild(name)

  input.classList.add("backoffice-file__input")
  input.classList.remove("backoffice-input")

  input.parentNode.insertBefore(wrap, input)
  wrap.appendChild(input)
  wrap.appendChild(ui)

  input.addEventListener("change", () => updateName(name, input))

  ;["dragenter", "dragover"].forEach((eventName) => {
    wrap.addEventListener(eventName, (event) => {
      event.preventDefault()
      wrap.classList.add("is-dragover")
    })
  })

  ;["dragleave", "drop"].forEach((eventName) => {
    wrap.addEventListener(eventName, (event) => {
      event.preventDefault()
      wrap.classList.remove("is-dragover")
    })
  })

  wrap.addEventListener("drop", (event) => {
    const files = event.dataTransfer && event.dataTransfer.files
    if (!files || files.length === 0) return

    const transfer = new DataTransfer()
    transfer.items.add(files[0])
    input.files = transfer.files
    input.dispatchEvent(new Event("change", { bubbles: true }))
  })
}

const initBackofficeFileInputs = () => {
  document
    .querySelectorAll(".backoffice-body input[type='file'].backoffice-input, .backoffice-body input[type='file'].backoffice-file__input")
    .forEach((input) => {
      if (input.classList.contains("backoffice-file__input") && input.closest(".backoffice-file")) return
      enhanceFileInput(input)
    })
}

export { initBackofficeFileInputs }
